/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react'
import MainLayout from '../../Layouts/Mainlayout'
import AddClientForm from './AddESPForm'
import AddESPTabs from './AddESPTabs'
import { useParams } from 'react-router-dom'

const AddESP: React.FC = () => {

    const param = useParams();
    const { id } = param;
    return (        
                <AddESPTabs parentId={id} />
    )
}

export default AddESP